import * as types from "./jenisDokumen.actionTypes";
import { action, createAsyncAction } from "typesafe-actions";
import { ErrorResponse } from "../../interfaces/ErrorResponse";
import { JenisDokumen, JenisDokumenRequest } from "../../interfaces/JenisDokumen";
import { JenisDokumenCreateResponse, JenisDokumenDetailResponse, JenisDokumenListResponse, JenisDokumenUpdateResponse } from "./types";

export const selectJenisDokumen = (jenisDokumen: JenisDokumen | null) => action(types.SELECT_JENIS_DOKUMEN, { jenisDokumen });

export const updateName = (name: string) => action(types.UPDATE_NAME, { name });
export const updateKode = (kode: string) => action(types.UPDATE_KODE, { kode });
export const updateStatus = (status: number) => action(types.UPDATE_STATUS, { status });
export const updateParent = (newId: number | null, newDetail: JenisDokumen | null) => action(types.UPDATE_PARENT, { newId, newDetail });

export const initializeCreateJenisDokumen = () => {
  const jenisDokumen: JenisDokumenRequest | null = {
    DOK_JENIS_ID: 0,
    DOK_JENIS_NAMA : '',
    DOK_JENIS_KODE: '',
    DOK_JENIS_PARENT: -1,
    STATUS: 1
  }

  return action(types.INITIALIZE_CREATE_JENIS_DOKUMEN, { jenisDokumen })
}

export const getJenisDokumenAsync = createAsyncAction(
  types.GET_JENIS_DOKUMEN_REQUEST,
  types.GET_JENIS_DOKUMEN_SUCCESS,
  types.GET_JENIS_DOKUMEN_FAILURE
)<{ status?: number }, JenisDokumenListResponse, ErrorResponse>();

export const getDetailJenisDokumenAsync = createAsyncAction(
  types.GET_DETAIL_JENIS_DOKUMEN_REQUEST,
  types.GET_DETAIL_JENIS_DOKUMEN_SUCCESS,
  types.GET_DETAIL_JENIS_DOKUMEN_FAILURE
)<{ id: number }, JenisDokumenDetailResponse, ErrorResponse>();

export const updateJenisDokumenAsync = createAsyncAction(
  types.UPDATE_JENIS_DOKUMEN_REQUEST,
  types.UPDATE_JENIS_DOKUMEN_SUCCESS,
  types.UPDATE_JENIS_DOKUMEN_FAILURE
)<JenisDokumen, JenisDokumenUpdateResponse, ErrorResponse>();

export const createJenisDokumenAsync = createAsyncAction(
  types.CREATE_JENIS_DOKUMEN_REQUEST,
  types.CREATE_JENIS_DOKUMEN_SUCCESS,
  types.CREATE_JENIS_DOKUMEN_FAILURE
)<JenisDokumen, JenisDokumenCreateResponse, ErrorResponse>();
